import React from "react";
import { Card, Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const UserPanel = () => {
    const navigate = useNavigate();
    const fullName = localStorage.getItem("fullName") || "Reporter";

    return (
        <Container className="mt-5">
            <Row>
                <Col md={8} className="mx-auto">
                    <Card className="shadow-lg border-0">
                        <Card.Body className="p-5 text-center">
                            <h1 className="mb-3">👋 Welcome, {fullName}!</h1>
                            <p className="text-muted fs-5 mb-4">
                                You have access to create and manage your news articles
                            </p>

                            <Row className="mt-4">
                                <Col md={6} className="mb-3">
                                    <Card
                                        className="border-0 bg-light cursor-pointer"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => navigate("/user-panel/add-news")}
                                    >
                                        <Card.Body>
                                            <div className="fs-1 mb-2">📰</div>
                                            <Card.Title>Add News</Card.Title>
                                            <Card.Text className="text-muted">
                                                Create and publish new articles
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                <Col md={6} className="mb-3">
                                    <Card
                                        className="border-0 bg-light cursor-pointer"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => navigate("/user-panel/manage-news")}
                                    >
                                        <Card.Body>
                                            <div className="fs-1 mb-2">🛠</div>
                                            <Card.Title>Manage News</Card.Title>
                                            <Card.Text className="text-muted">
                                                Edit and manage your articles
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default UserPanel;
